import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Sidebar from "../Components/sidebar/Sidebar";
import Navbar from "../Components/navbar/Navbar";
import { fadeUp } from "../theme/motion";
import "./Index_page.scss";

const Index_page = (props) => {
  const location = useLocation();
  const sidebarShow = useSelector((state) => state.sidebarShow);
  const contentRef = useRef(null);

  // Fade the page content in on every route change. anime.js handles transform
  // and opacity directly so it stays smooth on slow laptops.
  useEffect(() => {
    if (contentRef.current) fadeUp(contentRef.current);
  }, [location.pathname]);

  return (
    <div className={`sp-shell ${sidebarShow ? "is-open" : "is-collapsed"}`}>
      <Sidebar />
      <div className="sp-shell__main">
        <Navbar />
        <main className="sp-shell__content" ref={contentRef}>
          {props.page_route}
        </main>
      </div>
    </div>
  );
};

export default Index_page;
